import RestService from '../services/rest';

async function getEvents(gameMode) {
  return RestService.getAuthenticated(`calendars/${gameMode}/events`);
}

export default {
  getEvents,
};
